import { render, staticRenderFns } from "./TopVideo.vue?vue&type=template&id=b6539734"
import script from "./TopVideo.vue?vue&type=script&lang=js"
export * from "./TopVideo.vue?vue&type=script&lang=js"
import style0 from "./TopVideo.vue?vue&type=style&index=0&id=b6539734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports